<template>
  <div>
    <!-- <b-breadcrumb :items="items" @click="navigate"/> -->
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li
          class="breadcrumb-item"
          :class="{
            active: surveyStep == 1,
            'step-completed': maxStepCompleted >= 1
          }"
        >
          <a href="#" @click="moveToStep(1)">Step 1</a>
        </li>
        <li
          class="breadcrumb-item"
          :class="{
            active: surveyStep == 2,
            'step-completed': maxStepCompleted >= 2
          }"
        >
          <a href="#" @click="moveToStep(2)">Step 2</a>
        </li>
        <li
          class="breadcrumb-item"
          :class="{
            active: surveyStep == 3,
            'step-completed': maxStepCompleted >= 3
          }"
        >
          <a href="#" @click="moveToStep(3)">Step 3</a>
        </li>
        <li
          class="breadcrumb-item"
          :class="{
            active: surveyStep == 4,
            'step-completed': maxStepCompleted >= 4
          }"
        >
          <a href="#" @click="moveToStep(4)">Step 4</a>
        </li>
        <li
          class="breadcrumb-item"
          :class="{
            active: surveyStep == 5,
            'step-completed': maxStepCompleted >= 5
          }"
        >
          <a href="#" @click="moveToStep(5)">Step 5</a>
        </li>
        <li
          class="breadcrumb-item"
          :class="{
            active: surveyStep == 6,
            'step-completed': maxStepCompleted >= 6
          }"
        >
          <a href="#" @click="moveToStep(6)">Step 6</a>
        </li>
        <li
          class="breadcrumb-item"
          :class="{
            active: surveyStep == 7,
            'step-completed': maxStepCompleted >= 7
          }"
        >
          <a href="#" @click="moveToStep(7)">Step 7</a>
        </li>
        <li
          class="breadcrumb-item"
          :class="{
            active: surveyStep == 8,
            'step-completed': maxStepCompleted >= 8
          }"
        >
          <a href="#" @click="moveToStep(8)">Step 8</a>
        </li>
        <li class="breadcrumb-item" :class="{ active: surveyStep == 9 }">
          <a href="#" @click="moveToStep(9)">Finished</a>
        </li>
      </ol>
    </nav>
  </div>
</template>

<script>
export default {
  name: "surveyBreadcrumb",
  props: ["surveyStep", "maxStepCompleted", "surveyStepArr"],
  data: () => ({
    items: [
      {
        text: "Step 1",
        active: true
      },
      {
        text: "Step 2",
        active: false
      },
      {
        text: "Step 3",
        active: false
      },
      {
        text: "Step 4",
        active: false
      },
      {
        text: "Step 5",
        active: false
      },
      {
        text: "Step 6",
        active: false
      },
      {
        text: "Step 7",
        active: false
      }
    ]
  }),
  methods: {
    moveToStep(step) {
      console.log("Move to step: " + step);
      if (this.maxStepCompleted >= step) this.$emit("move-to-step", step);
    },
    navigate(step) {
      console.log(step);
      this.items.map(x => (x.active = false));
      this.items[step - 1].active = true;
      if (this.maxStepCompleted >= step) this.$emit("move-to-step", step);
    }
  }
};
</script>

<style>
.step-completed {
  background-color: blue;
  color: #ffffff;
}
</style>
